import React, { useState, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Collapse } from 'reactstrap'
import { nanoid } from 'nanoid'

import Button from '../Button'

const CollapsibleText = ({ openTitle, closeTitle, children, defaultOpen = false, justifyContent = 'start', cy }) => {
  const [isOpen, toggleOpen] = useState(defaultOpen)
  const id = nanoid()
  return (
    <Fragment>
      <div id={`collapsableDiv-${id}`}>
        <Collapse isOpen={isOpen} className='collapse-nav'>
          {children}
        </Collapse>
      </div>
      <div className='py-2'>
        <div className={`d-flex justify-content-${justifyContent}`}>
          <Button ghost className='p-0 d-flex align-items-center justify-content-start' data-cy={cy} onClick={() => toggleOpen(!isOpen)} aria-controls={`collapsableDiv-${id}`} aria-expanded={isOpen}>
            <span>{isOpen ? closeTitle : openTitle}</span>
          </Button>
        </div>
      </div>
    </Fragment>
  )
}

CollapsibleText.propTypes = {
  openTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  closeTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.element
  ]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element
  ]),
  defaultOpen: PropTypes.bool,
  justifyContent: PropTypes.string,
  cy: PropTypes.string
}

export default CollapsibleText
